module.exports = __webpack_public_path__ + "static/che18-db56fc380876ebf0f715aca2bd85b951.jpg";